import { useState } from "react";

export const ProductImage = ({ product }) => {
  const imageUrl = product.image_url;
  const [error, setError] = useState(false);

  if (error || !imageUrl) {
    return (
      <div
        className="bg-light border rounded d-flex align-items-center justify-content-center"
        style={{
          width: "80px",
          height: "80px",
        }}
      >
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="3"
            y="3"
            width="18"
            height="18"
            rx="2"
            ry="2"
            stroke="currentColor"
            strokeWidth="2"
          />
          <circle
            cx="8.5"
            cy="8.5"
            r="1.5"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      </div>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={product.product_name}
      className="border rounded"
      style={{
        width: "80px",
        height: "80px",
        objectFit: "contain",
      }}
      onError={() => setError(true)}
    />
  );
};
